import React, { useState, useEffect } from 'react';
import { convertiDataComputer2Umano, convertiImportoComputer2Umano } from './funzioni.js'
import VisualizzaRicevuta from '../Pagine/SchedaIncassiAbbAss/VisualizzaRicevuta.js';
import Carrello from "./Carrello.js"
import Clessidra from '../Pagine/Clessidra'
import stile from './stile.module.css';
import Cerchio_ok from './cerchio_ok.png';
import Cerchio_no from './cerchio_no.png';

function Movimenti(props) {
    const PAGINE = {
        "caricamentoDati": 1,
        "elencoMovimenti": 2,
        "visualizzaCarrello": 3
    };
    const [pagina, setPagina] = useState(PAGINE.caricamentoDati);
    const [elencoMovimenti, setElencoMovimenti] = useState([]);
    const [movimentiPassati, setMovimentiPassati]=useState([]);
    const [movimentiFuturi, setMovimentiFuturi]=useState([]);
    const [importoTotale, setImportoTotale] = useState(0);
    const [flagScaricaRicevuta, setFlagScaricaRicevuta] = useState(false);
    const [flagVisualizzaRicevuta, setFlagVisualizzaRicevuta] = useState(false);
    const [idRecordPrimaNota, setIdRecordPrimaNota] = useState(0);

    useEffect(() => {
        scaricaElencoMovimenti();
    }, [])
    
    // gestione del tasto BACK
    useEffect(() => {
        if (props.flagRichiestaBack) {
            props.setFlagRichiestaBack(false);
            props.callback(props.PAGINECLIENTI.home);
        } 
    }, [props.flagRichiestaBack])     

    function scaricaElencoMovimenti() {
        setPagina(PAGINE.caricamentoDati);
        var requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ op: "restituisciSituazioneInsolvente", emak: props.emak, sessionId: props.sessionId })
        };
        fetch(props.UrlBackend, requestOptions)
            .then(risposta => risposta.json())
            .then(
                (valore_di_ritorno) => {
                    if (valore_di_ritorno.verifvers === 0) {
                        // necessario aggiornare la app
                        props.callbackAggiornaApp();
                        return;
                    }
                    if (valore_di_ritorno.risultatoOperazione === 2) { props.callback(props.PAGINECLIENTI.login); return; }
                    if (valore_di_ritorno.risultatoOperazione !== 1) { 
                        window.alert("Sistema momentaneamente non disponibile. Se il problema persiste, contattare l'assistenza tecnica"); 
                        props.callback(props.PAGINECLIENTI.login);
                        return; 
                    }                    
                    setElencoMovimenti(valore_di_ritorno.movimenti);

                    const oggi = new Date();
                    oggi.setHours(0, 0, 0, 0); // Rimuove l'orario per il confronto "a mezzanotte"

                    // Converti elemento.DATA (es: "2025-07-18T00:00:00") in oggetto Date e confronta
                    const movimentiFinoAOggi = valore_di_ritorno.movimenti.filter(el => {
                    const dataEl = new Date(el.DATA.split(":")[0]);
                    dataEl.setHours(0, 0, 0, 0);
                    return dataEl <= oggi;
                    });
                    setMovimentiPassati(movimentiFinoAOggi);

                    const movimentiDopoOggi = valore_di_ritorno.movimenti.filter(el => {
                    const dataEl = new Date(el.DATA.split(":")[0]);
                    dataEl.setHours(0, 0, 0, 0);
                    return dataEl > oggi;
                    }).sort((a, b) => {
                    const da = new Date(a.DATA.split(":")[0]); da.setHours(0, 0, 0, 0);
                    const db = new Date(b.DATA.split(":")[0]); db.setHours(0, 0, 0, 0);
                    return da - db; // ordina i movimenti futuri in ordine crescente per data
                    });
                    setMovimentiFuturi(movimentiDopoOggi);


                    for (var i=0; i<valore_di_ritorno.totali.length; i++) {
                        if (valore_di_ritorno.totali[i].DATA=="Totale Quote (Associative + Abbonamento)") setImportoTotale(valore_di_ritorno.totali[i].IMPORTO);
                    }
                    setPagina(PAGINE.elencoMovimenti);               
                },
                (error) => {
                    props.callback(props.PAGINECLIENTI.login);
                    return;
                }
            );                                 
    }

    function StatoImporto({ importo }) {
        const valore = Number(importo);

        if (valore < 0) {
            if (valore < 0) {
                return (
                    <div className={[
                        stile.movimentiStatoImporto,
                        stile.movimentiStatoDaPagare
                    ].join(" ")}>
                        <span className={stile.movimentiStatoTesto}>
                            Acquistato
                        </span>

                        <span className={stile.movimentiStatoValore}>
                            {convertiImportoComputer2Umano(-valore)} €
                        </span>
                    </div>
                );
            }
        }

        if (valore > 0) {
            return (
                <div className={[
                    stile.movimentiStatoImporto,
                    stile.movimentiStatoPagato
                ].join(" ")}>
                    <img
                        src={Cerchio_ok}
                        className={stile.movimentiStatoIcona}
                        alt=""
                    />

                    <span className={stile.movimentiStatoTesto}>
                        Pagato
                    </span>

                    <span className={stile.movimentiStatoValore}>
                        {convertiImportoComputer2Umano(valore)} €
                    </span>
                </div>
            );
        }

        return (
            <div className={[
                stile.movimentiStatoImporto,
                stile.movimentiStatoNeutro
            ].join(" ")}>
                <span className={stile.movimentiStatoTesto}>
                    Importo
                </span>

                <span className={stile.movimentiStatoValore}>
                    0,00 €
                </span>
            </div>
        );
    }    

    if (pagina === PAGINE.caricamentoDati) {
        return (<Clessidra loading={true} />)
    }

    if (pagina === PAGINE.elencoMovimenti) {
        return (        
            <div style={{overflowY:'auto'}}>
                <div className={stile.movimentiElencoContenitoreElemento}>
                    <div className={importoTotale < 0 ? stile.movimentiTestoImportoNegativo : stile.movimentiTestoImportoPositivo}>
                        {
                            importoTotale < 0 ? "DEBITO ad oggi:\n" + convertiImportoComputer2Umano(-importoTotale) + " € da pagare" :
                            importoTotale > 0 ? "CREDITO ad oggi:\n" + convertiImportoComputer2Umano(importoTotale) + " € già pagati" :
                            "Non hai debiti o crediti ad oggi"
                        }                        
                    </div>

                    {props.identitaSelezionata.acq_app=="1" && importoTotale < 0 && 
                        <div className={[stile.baVerdeSoft, stile.baNormale, stile.baFlex].join(" ")} 
                            onClick={() => {
                                setPagina(PAGINE.visualizzaCarrello);
                            }}>
                            Paga adesso
                        </div>
                    }

                </div>
    
                {elencoMovimenti.length > 0 && !flagVisualizzaRicevuta ? (
                    <div>
                        <div className={stile.movimentiSpazioTitoloDettagli}>
                            <div className={stile.movimentiTestoTitoloDettagli}>Dettaglio pagamenti</div>
                        </div>
    
                        {movimentiPassati.map((x, i) => 
                            <div key={i} className={[stile.movimentiElencoContenitoreElemento,stile.movimentiScheda].join(" ")}>
                                <div style={{display: 'flex', flexDirection: 'row'}}>
                                    <div style={{flex: 1, justifyContent: 'center', paddingRight: 2}}>
                                        <div className={stile.movimentiTestoData}>{convertiDataComputer2Umano(x.DATA)}</div>
                                    </div>
                                    <div style={{flex: 1, paddingLeft: 4}}>
                                        <StatoImporto importo={x.IMPORTO} />
                                    </div>
                                </div>
                                <div style={{paddingTop: 5}}>
                                    <div className={stile.movimentiTestoOperazione}>
                                        {Array.isArray(x.JSON_DETTAGLI) ? (
                                            x.JSON_DETTAGLI.map((dettaglio, i) => (
                                            <div key={i}>{dettaglio.DESCRIZIONE}</div>
                                        ))
                                        ) : (
                                            x.OPERAZIONE
                                        )}
                                    </div>
                                </div>
                                {x.IMPORTO > 0 && 
                                    <div className={stile.movimentiSpazioBottoniRicevuta}>
                                        <div
                                            className={stile.movimentiBottoneRicevuta}
                                            onClick={() => {
                                                setIdRecordPrimaNota(x.ID);
                                                setFlagVisualizzaRicevuta(true);
                                            }}
                                        >
                                            Vedi Ricevuta
                                        </div>

                                        <div
                                            className={[
                                                stile.movimentiBottoneRicevuta,
                                                stile.movimentiBottoneRicevutaSecondo
                                            ].join(" ")}
                                            onClick={() => {
                                                setIdRecordPrimaNota(x.ID);
                                                setFlagScaricaRicevuta(true);
                                            }}
                                        >
                                            Scarica Ricevuta
                                        </div>
                                    </div>
                                }
                            </div>
                        )}

                        <div className={stile.movimentiSpazioTitoloDettagli}>
                            <div className={stile.movimentiTestoTitoloDettagli}>Prossimi Pagamenti</div>
                        </div>
    
                        {movimentiFuturi.length == 0 ? <div className={stile.movimentiElencoContenitoreElemento} style={{textAlign: 'center'}}>Non sono previsti prossimi pagamenti</div> :
                        movimentiFuturi.map((x, i) => 
                            <div key={i} className={[stile.movimentiElencoContenitoreElemento,stile.movimentiScheda].join(" ")}>
                                <div style={{display: 'flex', flexDirection: 'row'}}>
                                    <div style={{flex: 1, justifyContent: 'center', paddingRight: 2}}>
                                        <div className={stile.movimentiTestoData}>{convertiDataComputer2Umano(x.DATA)}</div>
                                    </div>
                                    <div style={{flex: 1, paddingLeft: 4}}>
                                        <StatoImporto importo={x.IMPORTO} />
                                    </div>
                                </div>
                                <div style={{paddingTop: 5}}>
                                    <div className={stile.movimentiTestoOperazione}>
                                        {Array.isArray(x.JSON_DETTAGLI) ? (
                                            x.JSON_DETTAGLI.map((dettaglio, i) => (
                                            <div key={i}>{dettaglio.DESCRIZIONE}</div>
                                        ))
                                        ) : (
                                            x.OPERAZIONE
                                        )}
                                    </div>
                                </div>
                                {x.IMPORTO > 0 && 
                                    <div className={stile.movimentiSpazioBottoniRicevuta}>
                                        <div
                                            className={stile.movimentiBottoneRicevuta}
                                            onClick={() => {
                                                setIdRecordPrimaNota(x.ID);
                                                setFlagVisualizzaRicevuta(true);
                                            }}
                                        >
                                            Vedi Ricevuta
                                        </div>

                                        <div
                                            className={[
                                                stile.movimentiBottoneRicevuta,
                                                stile.movimentiBottoneRicevutaSecondo
                                            ].join(" ")}
                                            onClick={() => {
                                                setIdRecordPrimaNota(x.ID);
                                                setFlagScaricaRicevuta(true);
                                            }}
                                        >
                                            Scarica Ricevuta
                                        </div>
                                    </div>                                    
                                }
                            </div>
                        )}                        
                    </div>
                ) : (
                    <></>
                )}

                {flagScaricaRicevuta && 
                    <VisualizzaRicevuta 
                        {...props} 
                        key={pagina + "-" + idRecordPrimaNota}
                        idRecordPrimaNota={idRecordPrimaNota} 
                        flagDownload={true}
                        callback={() => setFlagScaricaRicevuta(false)}
                    />
                }

                {flagVisualizzaRicevuta && 
                    <VisualizzaRicevuta 
                        {...props} 
                        key={pagina + "-" + idRecordPrimaNota}
                        idRecordPrimaNota={idRecordPrimaNota}
                        dimensioniApp={{"yMain":500}}
                        flagDownload={false}
                        callback={() => setFlagVisualizzaRicevuta(false)}
                    />
                }

            </div>
        );
    }    

    if (pagina === PAGINE.visualizzaCarrello) {
        return (
            <Carrello {...props} callback={() => props.callback(props.PAGINECLIENTI.home)}/>
        )
    }

    return (
        <div>Errore pagina non trovata (Movimenti)</div>
    )
}

export default Movimenti;
